<template>
    <div class="has-text-centered">
        <img class="error404" :src="error404" alt />
        <h1 class="title">Página não encontrada!</h1>
    </div>
</template>
<script>
import error404 from '@/assets/img/error404.svg';

export default {
    name: 'Error404Page',
    data() {
        return {
            error404,
        };
    },
    created() {
        if(!this.$cookies.get('token')) {
            this.$router.push({ name: 'login' });
        }
    },
};
</script>
<style lang="scss" scoped>
    .error404 {
        max-width: 600px;
    }
</style>
